import React from 'react';
import { BaseStatusCode } from "./BaseStatusCode.js";
import { Illustration404 } from "./illustrations/Illustration404.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusCode404 = ({
  className,
  title,
  description,
  component
}) => {
  return /*#__PURE__*/_jsx(BaseStatusCode, {
    className: className,
    illustration: /*#__PURE__*/_jsx(Illustration404, {}),
    title: title ?? 'Die gesuchte Seite ist hier leider nicht zuhause',
    description: description,
    component: component
  });
};